import prawoGierLowRes from 'assets/other-media/prawo-gier-LowRes.webp';
import prawoGier from 'assets/other-media/prawo-gier-1280.webp';
import polskiGamedevLowRes from 'assets/other-media/polski-gamedev-LowRes.jpg.webp';
import polskiGamedev from 'assets/other-media/polski-gamedev-1280.webp';
import chilliZetLowRes from 'assets/other-media/chilliZet-LowRes.webp';
import chilliZet from 'assets/other-media/chilliZet-1280.webp';

export const otherMedia = [
  {
    id: 1,
    LowQualityImage: prawoGierLowRes,
    HighQualityImage: prawoGier,
    link: 'https://korporacyjnie.pl/prawo-gier-wideo-wywiad-z-tworca/',
    title: '„Prawo Gier” – an interview about game design (article)',
  },
  {
    id: 2,
    LowQualityImage: polskiGamedevLowRes,
    HighQualityImage: polskiGamedev,
    link: 'https://polskigamedev.pl/polskigamedev-pl-2-zawartosc-numeru/',
    title:
      'Polskigamedev.pl - a column touching the topic of the narrative (magazine)',
  },
  {
    id: 3,
    LowQualityImage: chilliZetLowRes,
    HighQualityImage: chilliZet,
    link: 'https://player.chillizet.pl/Podcasty/Na-chilloucie/Maria-Piatkowska-opowiada-o-swoim-nowym-projekcie-grze-Evil-West/(offset)/2?fbclid=IwAR1cE0xvut6oeHLQN5phBTFffTS9ZT4fDIKLpRTagDHyYLpoquFUmTwJZaI',
    title: 'ChilliZet - Evil West (podcast)',
  },
];
